// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"98":"44fd71c0","703":"82deea3b","784":"5c77e4fe","952":"27825c38"}[chunkId] + ".css";
};